import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import SimpleLoader from './components/SimpleLoader.vue' // ✅ SIMPLE

const app = createApp(App)
app.component('SimpleLoader', SimpleLoader); // ✅ SIMPLE
app.use(store).mount('#app')